import { GrandstandButton } from '@/components/Buttons'
import { BaseContainer } from '@/components/containers/BaseContainer'
import { breakpoints } from '@/styles/breakpoints'
import { ButtonLabel, HeadingLabel, MetaDataLabel, ParagraphLabel, SubheadingLabel } from '@/styles/fonts'
import Link from 'next/link'
import styled from 'styled-components'

// From [[...flow]].tsx
export const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  color: var(--on-background);
`

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px;
  top: 0;
  left: 0;
`

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  row-gap: 25px;
`

export const BackgroundImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  padding-top: 50px;
  row-gap: 25px;
  background: url('/packages-upper-background.png');
  background-repeat: no-repeat;
  background-position: center top;
  min-height: 500px;
`

export const DisclaimerFooter = styled.div`
  bottom: 24px;
  font-size: var(--caption-sm-size);
  display: block;
  margin-top: auto;
  word-wrap: break-word;
  color: var(--on-background-alt);
  width: 80%;
`

export const SubscribeHeading = styled(HeadingLabel)`
  color: var(--on-dark);
`

export const ZipCodeEntryContainer = styled.div`
  display: flex;
  padding: 10px 16px;
  flex-direction: row;
  width: 390px;
  height: 56px;
  border: 1px solid var(--on-background-alt);
  border-radius: 4px;
  overflow: hidden;
  justify-content: space-between;
  @media (max-width: 768px) {
    width: 300px;
    height: 56px;
  }
`

export const ZipCodeInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 36px;
  width: -webkit-fill-available;
`

export const ZipCodeEntryLabel = styled(MetaDataLabel)`
  color: var(--on-dark);
  width: max-content;
`

export const ZipCodeInput = styled.input`
  width: 100%;
  height: 22px;
  border: none;
  background: none;
  color: var(--on-dark);
  &::placeholder {
    color: var(--on-dark);
  }
  &:focus {
    outline: none;
  }
`

export const ZipCityStateLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 36px;
  color: var(--on-dark);
`

export const CityStateValue = styled(MetaDataLabel)`
  color: var(--on-background);
  width: max-content;
  color: var(--on-dark);
`

export const AuthBtn = styled(GrandstandButton)`
  border: var(--button-alt);
`

export const ZipCodeMsg = styled(SubheadingLabel)`
  color: var(--on-dark);
  width: 390px;
  text-align: left;
  @media (max-width: 375px) {
    width: 300px;
  }
`

export const CheckoutBar = styled.div`
  position: fixed;
  z-index: 1;
  background: var(--canvas);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 32px 48px;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  left: 0px;
  bottom: 0px;
  box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.4);
  border-radius: 8px 8px 0px 0px;
`

export const CheckoutBarSummary = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px;
  gap: 16px;
  max-width: 632px;
  width: 100%;
  justify-content: center;
`

export const CheckoutBarSummaryTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px;
  gap: 4px;
  width: 273px;
`

export const CheckoutBarSummaryTitleText1 = styled(ParagraphLabel)`
  color: var(--on-background-alt);
`

export const CheckoutBarSummaryTitleText2 = styled(MetaDataLabel)`
  color: var(--on-background-alt);
  @media (max-width: 728px) {
    display: none;
  }
  display: flex;
`

export const CheckoutBarBtn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  width: 343px;
  height: 48px;
  background: var(--on-button-alt);
  border-radius: 4px;
  @media (max-width: 375px) {
    width: 300px;
  }
  :hover {
    cursor: pointer;
  }
`

export const CheckoutBarBtnText = styled(ButtonLabel)`
  text-transform: uppercase;
  color: var(--on-dark);

  @media (prefers-color-scheme: dark) {
    color: var(--on-light);
  }
`

export const FormContainer = styled.div`
  width: 528px;
  padding: 10px 20px;
  margin-top: 30px;
  border-radius: 8px;
  background-color: var(--surface);
  color: var(--on-light);
  @media screen and (max-width: 580px) {
    width: 80%;
  }
`

export const FaqsCtaContainer = styled(ParagraphLabel)`
  margin-top: 35px;
  text-align: center;
  width: 100%;
`

export const HavingTrouble = styled.div`
  margin-bottom: 48px;
  p {
    margin-top: 12px;
  }
  a {
    text-decoration: underline;
  }
`

export const FaqsContainer = styled(BaseContainer)`
  padding: 48px 16px;
  ${breakpoints.up('tablet')} {
    padding: 48px 24px;
  }
  ${breakpoints.up('desktop')} {
    padding: 48px;
  }
  text-align: left;
`

export const SectionHeading = styled(HeadingLabel)`
  margin-bottom: 24px;
`

export const ExpansionPanelContainer = styled.button`
  background: transparent;
  border: none;
  border-top: 1px solid var(--web-dark-divider-canvas, #2a2b2d);
  width: 100%;
  text-align: left;

  padding: 16px 0;
  ${breakpoints.up('tablet')} {
    padding: 24px 0;
  }
`

export const ExpansionPanelContent = styled.div<{ open?: boolean }>`
  display: ${({ open }) => (open ? 'visible' : 'none')};
  padding-top: 16px;
  ${breakpoints.up('tablet')} {
    padding-top: 24px;
  }
`

export const ExpansionPanelTitle = styled(SubheadingLabel)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const RegionLockedMessage = styled.div`
  width: 100%;
  background-color: var(--canvas);
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const ContactSupportLink = styled(Link)`
  text-decoration: underline;
`

export const FaqDiv = styled.div`
  margin-bottom: 16px;
  font-size: var(--sub-heading-2-size);
  color: var(--on-background-alt);
`

export const FaqOl = styled.ol`
  list-style-type: decimal;
  margin-left: 32px;
`

export const FaqUl = styled.ul`
  list-style-type: disc;
  margin-left: 32px;
`

export const FaqA = styled.a`
  text-decoration: underline;
`
